import { backCastActuals, totalAssetsLiquid } from '../../engine.js';
import { getMonthlyLedgerCache, getMonthlyLedgerSource } from '../../ledger-cache.js';
import {
  SOURCE_STATE_CLASSES,
  formatSourceStateLabel,
  normalizeSourceState,
} from '../../source-state.js';
import { CASH_LABELS } from './cash-monitor-model.js';

const STRICT_ACTUAL_CLASSES = new Set([
  SOURCE_STATE_CLASSES.CONTRACT_REAL,
  SOURCE_STATE_CLASSES.CONTRACT_BACKED,
]);

function lastOf(rows) {
  return Array.isArray(rows) && rows.length > 0 ? rows[rows.length - 1] : null;
}

function finiteOrNull(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function buildLedgerCashOpening({ scenario } = {}) {
  const sourceState = normalizeSourceState(
    scenario?._ledgerSourceState ||
    scenario?._ledgerSource ||
    getMonthlyLedgerSource(),
  );
  const actualRow = lastOf(backCastActuals(0));
  const cacheRow = lastOf(getMonthlyLedgerCache());
  const actualAmount = finiteOrNull(actualRow?.liquidEnding)
    ?? finiteOrNull(cacheRow?.liquidEnding)
    ?? totalAssetsLiquid();
  const strictActual = STRICT_ACTUAL_CLASSES.has(sourceState.sourceClass);
  const labels = strictActual
    ? [CASH_LABELS.ACTUAL_CASH]
    : [CASH_LABELS.ACTUAL_CASH, CASH_LABELS.SOURCE_LOCAL_DEMO];
  const sourceLabel = strictActual
    ? CASH_LABELS.ACTUAL_CASH
    : `${CASH_LABELS.ACTUAL_CASH} + ${CASH_LABELS.SOURCE_LOCAL_DEMO}`;

  return {
    amount: actualAmount,
    labels,
    sourceLabel,
    sourceState,
    provenanceKind: sourceState,
    evidence: {
      ledgerSource: scenario?._ledgerSource || getMonthlyLedgerSource(),
      actualRowSource: actualRow?.source || null,
      actualRowYM: actualRow?.ym || null,
      cacheRowYM: cacheRow?.ym || null,
      sourceStateLabel: formatSourceStateLabel(sourceState),
    },
  };
}
